module.exports = __webpack_public_path__ + "static/img/young_5.2aa58d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posters/young_5.jpg
// module id = GGSJ
// module chunks = 1